import { defineComponent as _defineComponent } from 'vue';
import PDialog from 'primevue/dialog';
import PButton from 'primevue/button';
import PTooltip from 'primevue/tooltip';

/**
 * General modal component with title, description, configurable content and optional footer with two buttons
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BActionsModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: null
    },
    hasDeleteButton: {
      type: Boolean,
      default: false
    },
    hasFooter: {
      type: Boolean,
      default: true
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    confirmTooltip: {
      type: String,
      default: null
    },
    cypressPrefix: {
      type: String,
      default: ''
    },
    dismissableMask: {
      type: Boolean,
      default: true
    },
    fullScreenOnMobile: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeOnEscape: {
      type: Boolean,
      default: true
    },
    hasCancel: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close', 'confirm'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var vTooltip = PTooltip;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var modalVisible = ref(props.showModal);
    var confirmTextLabel = computed(function () {
      var _props$confirmText;
      return (_props$confirmText = props.confirmText) !== null && _props$confirmText !== void 0 ? _props$confirmText : t('actions.confirm');
    });
    var cancelTextLabel = computed(function () {
      var _props$cancelText;
      return (_props$cancelText = props.cancelText) !== null && _props$cancelText !== void 0 ? _props$cancelText : t('actions.cancel');
    });
    watch(function () {
      return props.showModal;
    }, function (newValue) {
      modalVisible.value = newValue;
    });
    function closeModal() {
      emit('close');
    }
    function confirm() {
      emit('confirm');
    }
    return {
      __sfc: true,
      vTooltip: vTooltip,
      props: props,
      emit: emit,
      t: t,
      modalVisible: modalVisible,
      confirmTextLabel: confirmTextLabel,
      cancelTextLabel: cancelTextLabel,
      closeModal: closeModal,
      confirm: confirm,
      PDialog: PDialog,
      PButton: PButton
    };
  }
});